import { useState, useEffect, ChangeEvent } from "react";
import "./index.css";
import { audio } from "./App";

type SoundGroupProps = {
  transcript: string;
  resetTranscript: () => void;
};

function SoundGroup({ transcript, resetTranscript }: SoundGroupProps) {
  const [text, setText] = useState<string>("天道輪迴");
  const [textArray, setTextArray] = useState<string[]>([]);
  const [matchedKeyword, setMatchedKeyword] = useState<string>("");
  const [audioFile, setAudioFile] = useState<File | null>(null);

  useEffect(() => {
    let cleanText = text.replace("  ", " ");
    setText(cleanText);
    if (text) {
      setTextArray(text.split(" "));
    }
  }, [text]);

  useEffect(() => {
    if (text.trim().length === 0) {
      return;
    }
    if (textArray.some((keyword) => transcript.includes(keyword))) {
      const foundKeyword = textArray.find((keyword) =>
        transcript.includes(keyword)
      );
      setMatchedKeyword(foundKeyword + "");
      resetTranscript();
      console.log("got it");
      playAudio();
      setTimeout(function () {
        setMatchedKeyword("");
      }, 5000); // Delay of 100 milliseconds
    }
  }, [transcript]);

  const RemoveKeyword = (index: number) =>
    setText(text.replace(textArray[index], ""));

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    setAudioFile(file || null);

    if (file) {
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        const dataUrl = e.target?.result as string;
        const audioInput = document.getElementById(
          "audio-input"
        ) as HTMLInputElement;
        if (audioInput) {
          audioInput.value = dataUrl;
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const playAudio = () => {
    if (audioFile) {
      const audioUrl = URL.createObjectURL(audioFile);
      const audioElement = new Audio(audioUrl);
      audioElement.play();
    } else {
      audio.play();
    }
  };
  return (
    <div className="group-container">
      <input
        className="input-box"
        type="text"
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <input
          type="file"
          accept="audio/*"
          onChange={handleFileChange}
          className="file-input"
        />
        <button
          onClick={playAudio}
          disabled={!audioFile}
          className="play-button"
        >
          Play
        </button>
      </div>

      {/* {!matchedKeyword && <p>中了: {matchedKeyword}AAA</p>} */}

      <div style={{ display: "flex", flexDirection: "row" }}>
        {text.split(" ").map((tag, index) => {
          let matched = matchedKeyword === tag;
          if (tag.trim().length === 0) {
            return;
          }
          return (
            <div
              key={index}
              style={{
                margin: 5,
                fontSize: 12,
                padding: "5px 10px",
                borderRadius: 5,
                color: "white",
                backgroundColor: matched ? "#F23F42" : "#5E65EA",
              }}
              onClick={() => RemoveKeyword(index)}
            >
              {tag}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SoundGroup;
